// extracted by mini-css-extract-plugin
module.exports = {"nav":"O7Pmx"};